<template>
  <div class="app-container">
    <div class="nav-title">
      <img src="@/assets/arrow-left.png" class="arrow" @click="navBack" />
      <span class="title-text">App下载</span>
    </div>
    <div class="main-content">
      <div class="nav-row">
        <img src="@/assets/logo.png" class="logo" />
        <!-- <div class="logo-name">PG币</div> -->
      </div>

      <div class="content-box">
        <img src="@/assets/home-logo.png" class="logo" />
        <div class="download-text">下载PG币</div>
        <div class="slogan-text">充值无痕 安全无忧</div>
        <button class="download-btn ios-btn" @click="goIosDownload()">
          <img src="@/assets/ios.png" />
          <span>iPhone版本</span>
        </button>
        <button class="download-btn android-btn" @click="goAndroidDownload()">
          <img src="@/assets/android.png" />
          <span>Android版本</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Download",
  data() {
    return {
      urls: {},
    };
  },
  created() {},
  mounted() {},
  methods: {
    getAppDownData() {
      getAppDown().then((res) => {
        this.urls = res;
      });
    },
    goAndroidDownload() {
      window.open(process.env.VUE_APP_ANDROID_DOWNLOAD_URL, "_blank");
    },
    goIosDownload() {
      window.open(process.env.VUE_APP_IOS_DOWNLOAD_URL, "_blank");
      // var resp = await fetch(process.env.VUE_APP_IOS_DOWNLOAD_URL);
      // if (!resp.ok) {
      //     this.$toast("获取iOS下载链接失败", 1500) // 显示1.5秒
      //     return;
      // }
      // var json = await resp.json()
      // var jumpLink = json.link_jump
      // if (!jumpLink) {
      //     this.$toast("获取iOS下载链接失败", 1500) // 显示1.5秒
      //     return;
      // }
      // window.location.href = jumpLink
    },
    calcFontSize() {
      // 获取当前设备宽度
      const deviceWidth = document.documentElement.clientWidth;

      // 根据设计稿的宽度比例计算出合适的 font-size
      const baseFontSize = 37.5; // 基于750px设计稿的基准值
      const designWidth = 375; // 设计稿的宽度

      // 设置 <html> 的 font-size，确保页面内容按比例缩放
      document.documentElement.style.fontSize = `${
        baseFontSize * (deviceWidth / designWidth)
      }px`;
    },
    navBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  min-height: 100vh;
  background-color: #000;

  .nav-title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.12667rem;
    width: 100%;
    max-width: 10rem; // PC 端居中布局时与内容列同宽
    position: fixed;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 0;
    z-index: 999;
    background-color: #000;
    .title-text {
      color: #fff;
      font-family: "PingFang SC";
      font-size: 0.48rem;
      font-style: normal;
      font-weight: 400;
    }
    .arrow {
      position: absolute;
      left: 0.43rem;
      top: 50%;
      transform: translateY(-50%);
      height: 0.37333rem;
      width: 0.18667rem;
    }
  }

  .main-content {
    padding-top: 1.12667rem;

    .nav-row {
      display: flex;
      align-items: center;
      padding: 0.4rem 0.4rem 0 0.4rem;
      .logo {
        width: 2.5rem;
        flex-shrink: 0;
      }

      .logo-name {
        color: #fff;
        font-family: PangMenZhengDao;
        font-size: 0.48rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 0 0.23rem 0 0.2rem;
      }
    }

    .content-box {
      padding-top: 3.12rem;
      display: flex;
      flex-direction: column;
      align-items: center;

      .logo {
        width: 3.2rem;
        height: 3.2rem;
        flex-shrink: 0;
      }

      .download-text {
        display: flex;
        height: 1.06667rem;
        justify-content: center;
        align-items: center;
        margin-top: 0.37rem;
        color: #fff;
        font-family: "PingFang SC";
        font-size: 0.64rem;
        font-style: normal;
        font-weight: 400;
      }
      .slogan-text {
        display: flex;
        height: 1.06667rem;
        align-items: center;
        justify-content: center;
        margin-top: 0.53rem;
        color: #fff;
        font-family: "PingFang SC";
        font-size: 0.53333rem;
        font-style: normal;
        font-weight: 400;
        letter-spacing: 0.05333rem;
      }
      .download-btn {
        width: 6.53333rem;
        height: 1.33333rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        border-radius: 4.06rem;
        text-decoration: none;
        &:active {
          opacity: 0.8;
        }

        img {
          width: 0.93333rem;
          height: 0.93333rem;
          flex-shrink: 0;
        }
        span {
          font-family: "PingFang SC";
          font-size: 0.53333rem;
          font-style: normal;
          font-weight: 400;
          line-height: 150%; /* 0.8rem */
        }
      }
      .ios-btn {
        margin-top: 1.17rem;
        background: #2f2f2f;
        color: #fff;
      }
      .android-btn {
        margin-top: 0.67rem;
        background: #f8c057;
        color: #000;
      }
    }
  }
}
</style>
